import { render, staticRenderFns } from "./MarketingConsentBanner.vue?vue&type=template&id=65a93d78&scoped=true"
import script from "./MarketingConsentBanner.vue?vue&type=script&lang=ts"
export * from "./MarketingConsentBanner.vue?vue&type=script&lang=ts"
import style0 from "./MarketingConsentBanner.vue?vue&type=style&index=0&id=65a93d78&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65a93d78",
  null
  
)

export default component.exports